import AcceptCookie from './accept-cookie';


export default (di) => {
	di
		.setType({type: AcceptCookie, name: 'AcceptCookie', parent: 'PageComponent', mixins: ['apiMixin']})
	;
};
